import { Component, OnInit } from '@angular/core';
import {Size} from "../../services/size";

@Component({
    selector: 'app-labs',
    templateUrl: './labs.component.html',
    styleUrls: ['./labs.component.scss'],
    standalone: false
})
export class LabsComponent implements OnInit {
  public deviceType:string = '';

  public constructor(public size: Size) {
    this.deviceType = this.size.getDeviceType();
  }

  public ngOnInit(): void {
    this.deviceType = this.size.getDeviceType();
  }

}
